import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeShippingMethodAdcBoxTruckDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false,
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ChangeShippingMethodAdcBoxTruckDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="ChangeShippingMethodAdcBoxTruck">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>Your order qualifies for an ADC Box Truck shipment.</p>
                    <p><b>ADC Box Truck shipments are delivered direct with a liftgate to the ground. 
                        It does not include uncrating or any installation services. 
                        The fee for this service is $300.</b></p>
                    <p><b>Would you like to have it shipped ADC Box Truck?</b></p>
                   {this.props.deliveryMethod =="ADC LTL" && <div className="noButtonContainer">
                        <a onClick={(e) => this.props.continueDeliveryWithATL("ADC LTL", e)} className="noButton blueButton">No</a>
                    </div>}
                    {this.props.deliveryMethod =="ADC Box Truck" && <div className="noButtonContainer">
                        <a onClick={(e) => this.props.changeHandleNo(e)} className="noButton blueButton">No</a>
                    </div>}
                    {<div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={(e) => this.props.continueDeliveryWith("ADC Box Truck", e)}>Yes</a>
                    </div>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {state};
};

ChangeShippingMethodAdcBoxTruckDialog = connect(mapStateToProps)(ChangeShippingMethodAdcBoxTruckDialog);
export default ChangeShippingMethodAdcBoxTruckDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeShippingMethodAdcBoxTruckDialog.js